(() => {
  const init = () => {
    const intro = document.querySelector('[data-gp-plant-layout]');
    const section = intro?.closest('.shopify-section');
    const purchase = section?.querySelector('.hdt-product__buy-button');
    if (!section || !purchase) return;
    document.body.classList.add('gp-plant-sticky-managed');
    const updateVisibility = () => {
      const currentPurchase = section.querySelector('.hdt-product__buy-button');
      document.body.classList.toggle('gp-plant-form-passed', !!currentPurchase && currentPurchase.getBoundingClientRect().bottom <= 0);
    };
    let visibilityFrame;
    const scheduleVisibility = () => {
      if (visibilityFrame) return;
      visibilityFrame = requestAnimationFrame(() => {
        visibilityFrame = null;
        updateVisibility();
      });
    };
    window.addEventListener('scroll', scheduleVisibility, {passive: true});
    window.addEventListener('resize', scheduleVisibility, {passive: true});
    if ('IntersectionObserver' in window) new IntersectionObserver(scheduleVisibility, {threshold: [0, 1]}).observe(purchase);
    updateVisibility();
    const configElement = section.querySelector('[data-gp-plant-sticky-config]');
    if (!configElement) return;
    const config = JSON.parse(configElement.textContent);
    const byId = new Map(config.variants.map(variant => [String(variant.id), variant]));
    const fields = () => [...section.querySelectorAll('hdt-variant-picker fieldset')];
    const selected = () => fields().map(field => field.querySelector('input[is-value]:checked')?.value);
    const match = values => config.variants.find(variant => variant.options.every((value, i) => value === values[i]));
    const resolve = (values, index) => {
      const exact = match(values);
      if (exact) return exact.available ? exact : null;
      return config.variants.filter(variant => variant.available && variant.options[index] === values[index])
        .sort((a, b) => b.options.filter((v, i) => v === values[i]).length - a.options.filter((v, i) => v === values[i]).length)[0];
    };
    const initializedIncludes = new WeakSet();
    const enhance = () => {
      for (const details of section.querySelectorAll('.gp-en-included')) {
        if (initializedIncludes.has(details)) continue;
        details.open = window.matchMedia('(min-width: 768px)').matches;
        initializedIncludes.add(details);
      }
      scheduleVisibility();
      const native = section.querySelector('.hdt-sticky-atc__variant-price select[name="id"]');
      if (!native || native.options.length !== config.variants.length || fields().length !== config.options.length) return;
      const variant = match(selected()) || byId.get(native.value);
      if (!variant) return;
      let controls = native.parentElement.querySelector('.gp-plant-sticky-options');
      if (!controls) {
        controls = document.createElement('div');
        controls.className = 'gp-plant-sticky-options';
        controls.style.setProperty('--gp-option-count', config.options.length);
        config.options.forEach((name, index) => {
          const label = document.createElement('label');
          const caption = document.createElement('span');
          caption.className = 'gp-plant-sticky-caption';
          caption.textContent = name;
          if (index === 0) {
            const price = document.createElement('span');
            price.className = 'gp-plant-sticky-price';
            price.setAttribute('aria-live', 'polite');
            caption.append(price);
          }
          const select = document.createElement('select');
          select.dataset.gpPlantOption = index;
          select.setAttribute('aria-label', (config.zh ? '底部' : 'Sticky ') + name);
          for (const value of new Set(config.variants.map(v => v.options[index]))) {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = value;
            select.append(option);
          }
          label.append(caption, select);
          controls.append(label);
        });
        native.insertAdjacentElement('afterend', controls);
      }
      const price = controls.querySelector('.gp-plant-sticky-price');
      if (price.textContent !== variant.price) price.textContent = variant.price;
      for (const select of controls.querySelectorAll('select')) {
        const index = Number(select.dataset.gpPlantOption);
        select.value = variant.options[index];
        for (const option of select.options) {
          const values = [...variant.options];
          values[index] = option.value;
          option.disabled = !resolve(values, index);
        }
      }
    };
    section.addEventListener('change', event => {
      const control = event.target;
      if (!control.matches('select[data-gp-plant-option]')) return;
      event.stopPropagation();
      const values = selected();
      const index = Number(control.dataset.gpPlantOption);
      values[index] = control.value;
      const variant = resolve(values, index);
      if (!variant) return enhance();
      const inputs = fields().map((field, i) => [...field.querySelectorAll('input[is-value]')].find(input => input.value === variant.options[i]));
      if (inputs.some(input => !input || input.disabled)) return enhance();
      const changed = inputs.filter(input => !input.checked);
      for (const input of changed.slice(0, -1)) input.checked = true;
      changed.at(-1)?.click();
      enhance();
    }, true);
    enhance();
    new MutationObserver(enhance).observe(section, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
